import { __assign } from 'tslib';
import { jsx, Fragment, jsxs } from '@emotion/react/jsx-runtime';
import { Box } from '../Box/index.js';
import { calcPartialTopLine, calcPartialBottomLine, calcFullLine, sizePaddingMap } from './utils.js';
import { useTreeCardContext } from './TreeProvider.js';

var TreeLines = function (props) {
    var levelHistory = props.levelHistory, cardHeight = props.height;
    var size = useTreeCardContext().size;
    var cardPadding = sizePaddingMap[size];
    return (jsx(Fragment, { children: levelHistory.map(function (_a, i) {
            var level = _a.level, isParentLastNode = _a.isParentLastNode, node = _a.node;
            if (level === 1)
                return null;
            var isFullLine = i + 1 < levelHistory.length;
            var showFullLine = !isParentLastNode;
            return (jsxs(Box, __assign({ sx: {
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    height: "".concat(cardHeight, "px"),
                    marginLeft: "var(--line-box-width)",
                } }, { children: [!isFullLine && (jsxs(Fragment, { children: [jsx(Box, { "data-node-line-top": true, sx: {
                                    "&::before": __assign({ content: '""', position: "absolute", borderLeft: "2px solid", borderBottom: "2px solid", borderColor: "black.20" }, calcPartialTopLine(isParentLastNode)),
                                    flex: 1,
                                } }), !isParentLastNode && (jsx(Box, { "data-node-line-bottom": isParentLastNode, sx: {
                                    "&::before": __assign({ content: '""', position: "absolute", borderLeft: "2px solid", borderColor: "black.20" }, calcPartialBottomLine(cardHeight, cardPadding)),
                                    flex: 1,
                                } }))] })), isFullLine && showFullLine && (jsx(Box, { "data-node-line-full": true, sx: {
                            "&::before": __assign({ content: '""', position: "absolute", borderLeft: "2px solid", borderColor: "black.20" }, calcFullLine(cardHeight)),
                            flex: 1,
                        } }))] }), node === null || node === void 0 ? void 0 : node.id));
        }) }));
};
TreeLines.displayName = "TreeLines";

export { TreeLines };
//# sourceMappingURL=TreeLines.js.map
